const QUARTALS_ID = /^(\d{4})\.([1-4])\.(\d+)$/;

/**
 * Nächste Release-ID im Schema `JJJJ.Q.N` für das Quartal von `heute` (lokale Zeit):
 * höchste vorhandene N dieses Quartals plus eins, sonst 1. IDs anderer Quartale oder
 * anderer Form (`2026.3`, `2026.4.3-rc1`) zählen nicht.
 */
export function naechsteReleaseId(ids: readonly string[], heute: Date): string {
  const jahr = heute.getFullYear();
  const quartal = Math.floor(heute.getMonth() / 3) + 1;
  const hoechste = ids.reduce((max, id) => {
    const treffer = QUARTALS_ID.exec(id);
    if (!treffer || Number(treffer[1]) !== jahr || Number(treffer[2]) !== quartal) return max;
    return Math.max(max, Number(treffer[3]));
  }, 0);
  return `${jahr}.${quartal}.${hoechste + 1}`;
}
